/* src/app/shared/price-input/price-input.component.css */
.price-error {
  color: red !important;
}
/*# sourceMappingURL=price-input.component.css.map */
